var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSapling = function SvgSapling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 99 101"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBED",
    d: "M50.36 100.714c24.885 0 45.06-2.468 45.06-5.511s-20.175-5.51-45.06-5.51S5.3 92.158 5.3 95.202s20.175 5.511 45.06 5.511",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28C07F",
    d: "M98.052.13s0 24.798-7.952 33.064c-7.953 8.267-23.852 13.782-29.155 9.642s-9.274-15.158-2.65-23.424C64.922 11.146 76.85 8.391 84.803 7.01A26.47 26.47 0 0 0 98.052.13M0 18.047s14.577-8.266 25.179-6.891c10.6 1.375 18.553 6.89 21.202 16.532s-3.002 15.305-9.274 17.913c-6.625 2.756-14.577 0-19.88-11.022C11.922 23.558 0 18.047 0 18.047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F9B7B",
    d: "M55.66 92.443s-2.649 5.511-9.279 0c0 0 2.654-19.282 2.654-24.798a33.7 33.7 0 0 0-1.327-15.152C45.06 45.6 33.131 34.58 30.482 31.824c-2.65-2.755-7.953-6.886-5.303-6.886 2.649 0 9.279 2.75 15.884 9.642 6.604 6.89 11.928 13.782 11.928 13.782s6.625-13.782 10.59-17.908c3.967-4.125 14.578-16.532 18.554-13.782s-6.625 8.266-9.28 11.022c-2.653 2.755-14.576 20.663-15.883 26.174S55.66 92.443 55.66 92.443"
  })));
};
export default SvgSapling;